/* Store initialization */
export const LOAD_DATA = 'LOAD_DATA'
